export default __webpack_public_path__ + "static/media/battle.46d1651f.png";